import { GetApiResponseByUrl } from '@crossbeam/openapi';

export const CUSTOMERS_STANDARD_TYPE = 'customers';
export const OPEN_OPPS_STANDARD_TYPE = 'open_opportunities';
export const PROSPECTS_STANDARD_TYPE = 'prospects';

export const STANDARD_POPULATIONS = [
  CUSTOMERS_STANDARD_TYPE,
  OPEN_OPPS_STANDARD_TYPE,
  PROSPECTS_STANDARD_TYPE,
] as const;

export type StandardPopulationType =
  | typeof PROSPECTS_STANDARD_TYPE
  | typeof OPEN_OPPS_STANDARD_TYPE
  | typeof CUSTOMERS_STANDARD_TYPE;

export type PopulationStats =
  GetApiResponseByUrl<'/alpha/population-stats'>['items'][number];

type Primitive = string | number | boolean | null;
export type Operand = Primitive | Primitive[];
export type Combinator = 'AND' | 'OR';

type FilterExpression = string[];

export type Population =
  GetApiResponseByUrl<'/v0.3/populations'>['items'][number];
export type FilterPart = NonNullable<
  NonNullable<Population['source_filter_expressions']>[string]['filter_parts']
>[number];

export type FilterGroup = {
  filter_expression: FilterExpression;
  filter_parts: FilterPart[];
};

export type EmptyPopulation = Partial<Population>;

export type PartnerPopulation =
  GetApiResponseByUrl<'/v0.1/partner-populations'>['items'][number];
